<template>
  <div class="jl-engage" :class="{ 'jl-engage--mobile': mobile }">
    <section v-if="loadingPosts || challengeItems.length" class="jl-engage__card">
      <div class="jl-engage__header">
        <h2 class="jl-engage__title">Featured challenges</h2>
        <router-link :to="{ name: 'posts' }" class="jl-engage__all">View all</router-link>
      </div>

      <div v-if="loadingPosts" class="jl-engage__list">
        <div class="jl-engage__item jl-engage__item--skeleton" v-for="n in 2" :key="'csk-' + n">
          <div class="jl-engage__skel-line jl-engage__skel-line--sm"></div>
          <div class="jl-engage__skel-line"></div>
        </div>
      </div>

      <ul v-else class="jl-engage__list">
        <li v-for="post in challengeItems" :key="post.id || post.post_id">
          <a :href="getPostLink(post)" class="jl-engage__item">
            <span class="jl-engage__tag">{{ getPostCategory(post).label }}</span>
            <span class="jl-engage__name">{{ getPostTitle(post) }}</span>
            <span class="jl-engage__cta">{{ getPostCtaLabel(post) }} →</span>
          </a>
        </li>
      </ul>
    </section>

    <section v-if="courseItems.length" class="jl-engage__card">
      <div class="jl-engage__header">
        <h2 class="jl-engage__title">Upskill courses</h2>
        <a :href="coursesHref" class="jl-engage__all" @click.prevent="goToCourses">View all</a>
      </div>
      <ul class="jl-engage__list">
        <li v-for="course in courseItems" :key="course.url">
          <a
            :href="course.url"
            class="jl-engage__item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span v-if="course.category" class="jl-engage__tag">{{ course.category }}</span>
            <span class="jl-engage__name">{{ course.name }}</span>
            <span class="jl-engage__meta">{{ course.institute }}</span>
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import { TRENDING_COURSES } from '@/constants/homePageData';
import { SITE_HOME } from '@/utils/previewRoutes';
import { scrollToSection } from '@/utils/scrollToSection';
import {
  getPostTitle,
  getPostCategory,
  getPostCtaLabel,
  getPostLink,
} from '@/utils/postHelpers';

export default {
  name: 'JobsListSidebarEngage',
  props: {
    posts: { type: Array, default: () => [] },
    loadingPosts: { type: Boolean, default: false },
    mobile: { type: Boolean, default: false },
  },
  computed: {
    challengeItems() {
      return (this.posts || []).slice(0, 2);
    },
    courseItems() {
      return TRENDING_COURSES.slice(0, 2);
    },
    coursesHref() {
      return `${SITE_HOME}#upskilling-courses`;
    },
  },
  methods: {
    getPostTitle,
    getPostCategory,
    getPostCtaLabel,
    getPostLink,
    goToCourses() {
      const onHome = this.$route.name === 'home'
        || this.$route.path === SITE_HOME
        || this.$route.path === '/';
      if (onHome) {
        scrollToSection('upskilling-courses', { behavior: 'smooth', settle: true });
        return;
      }
      this.$router.push({ name: 'home', hash: '#upskilling-courses' }).catch(() => {});
    },
  },
};
</script>
